import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-ppk-downloader-help-dialog',
  templateUrl: './ppk-downloader-help-dialog.component.html',
  styleUrls: ['./ppk-downloader-help-dialog.component.scss']
})
export class PpkDownloaderHelpDialogComponent {
  constructor(private readonly dialogRef: MatDialogRef<PpkDownloaderHelpDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}


